import { call, takeEvery, put, select, delay, all } from "redux-saga/effects";
import * as customerActions from "../actions/customers";
import { message } from "antd";
import {
  addCustomer,
  getAllCustomers,
  getFilterCustomers,
  getCustomerById,
  uploadCustomerPhoto,
  editCustomer
} from "../../api/customers";
import showSuccessWindow from "../../../../common/components/successPopup/successPopup";
import history from "../../../../common/history";
// import * as URLs from "../../../../common/constants/systemUrls";
import {
  successEditCustomer,
  successAddCustomer
} from "../../components/EditCustomer/success";
// import { showAlert } from "../../../../common/redux/actions/alert";
import { errorProcessing } from "../../../Employees/api/errorProcessing";
import { getSubjectIdBySubjectKeyRequest } from "../../../../common/api/filters/getSubjectIdBySubjectKeyRequest";

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

const getUserRole = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.roleId
  );
};

const getCustomerCompanyId = state => {
  return (
    state.Customers &&
    state.Customers.customerCard &&
    state.Customers.customerCard.customer &&
    state.Customers.customerCard.customer.companyId
  );
};

const getCustomerProfileId = state => {
  return (
    state.Customers &&
    state.Customers.customerCard &&
    state.Customers.customerCard.customer &&
    state.Customers.customerCard.customer.profileId
  );
};

const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};

/*
const getFullName = data => {
  return (
    `${data.lastname} ${data.name}` +
    (data.patronymic ? ` ${data.patronymic}` : '')
  );
};
*/
function* uploadCustomerPhotoSaga(action) {
  try {
    const { payload } = action;

    const response = yield call(uploadCustomerPhoto, payload);
    yield put(customerActions.uploadCustomerPhotoSuccess(response));
  } catch (error) {
    yield put(customerActions.uploadCustomerPhotoError(error));
  }
}

function* editCustomerSaga(action) {
  const activeProfileId = yield select(getActiveProfileId);
  const userId = yield select(getUserId);
  const companyId = yield select(getCustomerCompanyId);
  const customerProfileId = yield select(getCustomerProfileId);

  if (activeProfileId) {
    try {
      const { payload } = action;
      const subjectId = yield call(
        getSubjectIdBySubjectKeyRequest,
        action.payload.subjectKey
      );
      const response = yield call(
        editCustomer,
        { ...payload, subjectId, companyId },
        activeProfileId,
        userId,
        customerProfileId
      );
      yield put(customerActions.editCustomerSuccess(response));
      showSuccessWindow(
        successEditCustomer(
          payload.nameLegal ||
            (payload.name &&
              payload.lastname &&
              `${payload.name} ${payload.lastname}`) ||
            ""
        )
      );
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        yield call(message.error(error.response.data.message, 5));
      } else {
        console.error(error);
        yield call(
          message.error(
            "Произошла непредвиденная ошибка, обратитесь к разработчику",
            5
          )
        );
      }
      yield all([
        // put(showAlert(error)),
        put(customerActions.editCustomerError(errorProcessing(error)))
      ]);
    }
  } else {
    let activeProfileId = yield select(getActiveProfileId);
    let roleId = yield select(getUserRole);
    activeProfileId && roleId
      ? customerActions.editCustomer(roleId, activeProfileId, action.payload)
      : history.push("/authorization/profiles");
  }
}

function* getCustomerSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);

  if (activeProfileId) {
    try {
      const { payload } = action;
      const response = yield call(getCustomerById, payload);
      yield put(customerActions.getCustomerSuccess(response));
    } catch (err) {
      yield put(customerActions.getCustomerError(errorProcessing(err)));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(customerActions.getCustomer(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* getFilterCustomersSaga(action) {
  let activeProfileId = yield select(getActiveProfileId);
  if (activeProfileId) {
    try {
      const { payload } = action;
      const response = yield call(getFilterCustomers, payload);
      let customersStat = {};
      let customerTypes = {};
      response.forEach(item => {
        if (item.status) {
          const { profileStatusKey } = item.status;
          if (!customerTypes.hasOwnProperty(profileStatusKey)) {
            customerTypes[profileStatusKey] = {
              key: profileStatusKey,
              status: item.status.profileStatus
            };
            customersStat.hasOwnProperty(item.status.profileStatusKey)
              ? customersStat[profileStatusKey]++
              : (customersStat[profileStatusKey] = 1);
          }
        }
      });
      yield put(
        customerActions.getFilterCustomersSuccess({
          customers: response,
          customersStat,
          customerTypes: Object.keys(customerTypes).map(
            key => customerTypes[key]
          )
        })
      );
    } catch (error) {
      yield put(customerActions.getFilterCustomersError(error));
    }
  } else {
    yield delay(500);
    activeProfileId = yield select(getActiveProfileId);
    activeProfileId
      ? yield put(customerActions.getFilterCustomers(action.payload))
      : history.push("/authorization/profiles");
  }
}

function* getAllCustomersSaga(action) {
  const companyId = action.payload && action.payload.companyId;
  const search = (action.payload && action.payload.search) || "";
  const sort = (action.payload && action.payload.sort) || {};

  const response = yield call(getAllCustomers, companyId, search, sort);

  let customerTypes = {};
  let customersStat = {};

  response.forEach(item => {
    if (item.status && item.status.profileStatusKey) {
      const { profileStatusKey } = item.status;
      if (!customerTypes.hasOwnProperty(profileStatusKey)) {
        customerTypes[profileStatusKey] = {
          key: profileStatusKey,
          status: item.status.profileStatus
        };
      }
      customersStat.hasOwnProperty(profileStatusKey)
        ? customersStat[profileStatusKey]++
        : (customersStat[profileStatusKey] = 1);
    }
  });

  yield put(
    customerActions.getAllCustomersSuccess({
      customers: response,
      customerTypes: Object.keys(customerTypes).map(key => customerTypes[key]),
      customersStat
    })
  );
}

function* addCustomerSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(addCustomer, { ...payload });

    yield put(customerActions.addCustomerSuccess(response));
    history.push("/customers");

    showSuccessWindow(
      successAddCustomer(
        payload.nameLegal ||
          (payload.name &&
            payload.lastname &&
            `${payload.name} ${payload.lastname}`) ||
          ""
      )
    );
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      yield call(message.error(error.response.data.message, 5));
    } else {
      yield call(
        message.error(
          "Произошла непредвиденная ошибка, обратитесь к разработчику"
        )
      );
    }
    yield put(customerActions.addCustomerError(error));
  }
}

export function* customersSagas() {
  yield takeEvery(customerActions.addCustomer.toString(), addCustomerSaga);
  yield takeEvery(
    customerActions.getFilterCustomers.toString(),
    getFilterCustomersSaga
  );
  yield takeEvery(customerActions.getCustomer.toString(), getCustomerSaga);

  yield takeEvery(
    customerActions.getAllCustomers.toString(),
    getAllCustomersSaga
  );

  yield takeEvery(
    customerActions.uploadCustomerPhoto.toString(),
    uploadCustomerPhotoSaga
  );
  yield takeEvery(customerActions.editCustomer.toString(), editCustomerSaga);
}
